import { Pipe, PipeTransform } from '@angular/core';
import type { DeprecatedMarketingMenu } from '../../../models/menu/deprecated-marketing-menu';

@Pipe({
  name: 'deprecatedMarketingMenuBasicMethod',
  standalone: false
})
export class DeprecatedMarketingMenuBasicMethodPipe implements PipeTransform {
  /**
   * @deprecated use MethodPipe instead
   */
  transform(productMenu: DeprecatedMarketingMenu, methodKey: string, argument?: any): any {
    return productMenu?.[methodKey]?.(argument);
  }
}
